import { useEffect, useState } from "react";
import "./extensionCourses.scss";
import ExtensionCoursesTemplate from "componets/templates/extensionCoursesTemplate/extensionCoursesTemplate";
import axios from "axios";
import { baseURL } from "utilities/variables";
const ExtensionCourses = () => {
  const [pageData, setPageData] = useState(undefined);
  const [cursosExtension, setCursosExtension] = useState(undefined);
  const [data, setData] = useState([pageData, cursosExtension]);
  useEffect(() => {
    let auxData = [pageData, cursosExtension];

    setData(auxData);
  }, [pageData, cursosExtension]);
  useEffect(() => {
    axios
      .get(
        baseURL +
          "/api/pagina-cursos-de-extension?populate=encabezado.imagenPrincipal.imagen"
      )
      .then((response) => {
        let auxData = response.data.data;
        let auxEasyData = {
          header: auxData.attributes.encabezado,
          headerImgURL: `${baseURL}${auxData.attributes.encabezado.imagenPrincipal.imagen.data.attributes.url}`,
          headerAlt:
            auxData.attributes.encabezado.imagenPrincipal.imagen.data.attributes
              .alternativeText,
        };
        setPageData(auxEasyData);
      });

    axios
      .get(
        baseURL +
          "/api/lista-cursos-de-extensions?populate=imagenPrincipal.imagen"
      )
      .then((response) => {
        let auxData = response.data.data;
        let auxEasyData = [];
        auxData.map((value) => {
          auxEasyData.push({
            titulo: value.attributes.titulo,
            url: value.attributes.url,
            imgURL: `${baseURL}${value.attributes.imagenPrincipal.imagen.data.attributes.url}`,
            alt: value.attributes.imagenPrincipal.imagen.data.attributes
              .alternativeText,
            type: "SEMILLERO",
            color: "#F5F5F5",
          });
        });
        setCursosExtension(auxEasyData);
      });
  }, []);

  return (
    <div className="extension-courses__main-container">
      {data[0] !== undefined && data[1] !== undefined && data[1].length > 0 && (
        <ExtensionCoursesTemplate contentData={data} />
      )}
    </div>
  );
};

export default ExtensionCourses;
